import { PagesizeType } from '../../event/service/pagination/pagesize-type';
import { Constants } from './../../shared/constants';
import { Injectable } from '@angular/core';
import { LogService } from '../../shared/log/log.service';
import { UserPermission } from '../models/user-permission.model';
import 'polyfills';
import { DashboardFilterState } from '../../event/dashboard/dashboard-page/dashboard-filter';

@Injectable()
export class UserLocalStorageService {
  private readonly TOKEN_NAME = 'id_token';
  private readonly EMAIL_PREFIX = 'dashboard_filters_';

  constructor(
    private logService: LogService
  ) { }

  getToken(): string {
    try {
      return this.fromUserPermissions().token;
    } catch (error) {
      this.removeUserToken();
      this.logService.error('Unable to read token' + error);
      return null;
    }
  }

  getPermissions(): string[] {
    try {
      return this.fromUserPermissions().permissions;
    } catch (error) {
      this.removeUserToken();
      this.logService.error('Unable to read token' + error);
      return [];
    }
  }

  getDashboardFilterState(email: string): DashboardFilterState {
    email = this.EMAIL_PREFIX + email;
    const dashboardFilterStateJson = this.getItemAsJson(email);
    return new DashboardFilterState(dashboardFilterStateJson);
  }

  removeUserToken(): void {
    this.removeItem(this.TOKEN_NAME);
  }

  setUserToken(userPermission: UserPermission): void {
    this.setItem(this.TOKEN_NAME, JSON.stringify(userPermission));
  }

  setDashboardFilterState(email: string, dashboardFilterState: DashboardFilterState): void {
    email = this.EMAIL_PREFIX + email;
    this.setItem(email, JSON.stringify(dashboardFilterState));
  }

  private fromUserPermissions(): UserPermission {
    return new UserPermission(this.getItemAsJson(this.TOKEN_NAME));
  }

  setItem(key, value): void {
    localStorage.setItem(key, value);
  }

  getItem(key): string {
    return localStorage.getItem(key);
  }

  getItemAsJson(key): Object {
    try {
      const stringItem = this.getItem(key);
      if (stringItem != null) {
        return JSON.parse(stringItem);
      }
    } catch (error) {
      this.removeItem(key);
      this.logService.error('Unable to read token' + error);
    }

    return null;
  }

  removeItem(key): void {
    localStorage.removeItem(key);
  }

  get length(): number {
    return localStorage.length;
  }

  key(i): string {
    return localStorage.key(i);
  }

  public setToken(token: string) {
    let userPermission = this.getItemAsJson(this.TOKEN_NAME) as UserPermission;
    userPermission.token = token;
    this.setUserToken(userPermission);
  }

  resetPagesizes() {
    this.setPagesize(PagesizeType.EVENTS, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.GROUP_RESERVATIONS_SUMMARY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.GROUP_RESERVATIONS_NO_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.GROUP_RESERVATIONS_PARTIAL_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.GROUP_RESERVATIONS_EXACT_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.RSVP_SUMMARY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.RSVP_NO_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.RSVP_PARTIAL_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.RSVP_EXACT_MATCHES, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.TRANSIENT_RESERVATIONS, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.PAYMENT_RESERVATIONS, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.PAYMENT_RSVP, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
    this.setPagesize(PagesizeType.MATCHING_PROPERTY, Constants.SEARCH_DEFAULT_ITEMS_PER_PAGE);
  }

  getPagesize(pagesizeType: PagesizeType): number {
    return + this.getItem(pagesizeType);
  }

  setPagesize(pagesizeType: PagesizeType, pagesize: number) {
    this.setItem(pagesizeType, pagesize);
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/permission/services/user.local.storage.service.ts